export default "__VITE_ASSET__BW$Xe4SU__"